module.exports = __webpack_public_path__ + "static/img/doar.6578199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/doar.jpg
// module id = xi+F
// module chunks = 6